import { cloudApi } from '../api/index';
import {
  ONE_DAY,
  formatTime,
  ROOM_TYPE,
  statTxt,
  _setDefaultMapImg,
  isWarnDay,
} from '../base/CONST';
const { getCloudList, getCloudOverview, cloudSearch } = cloudApi;
const debounce = function debounce(fun, delay) {
  return function (args) {
    const that = this;
    const _args = args;
    clearTimeout(fun.id);
    fun.id = setTimeout(function () {
      fun.call(that, _args);
    }, delay);
  };
};
const ACTIVE_NAME = ['none', 'all', 'using', 'expired'];
export default {
  data() {
    return {
      isDeveloper: false,
      initDataLoading: true,
      noAnyServer: false,
      multipleSelectionAll: [],
      multipleSelectionUsing: [],
      multipleSelectionExpired: [],
      currServersCount: 0,
      ROOM_TYPE,
      UNIT: 10000,
      allData: [],
      serversExpired: [],
      serversUsing: [],
      activeName: '1', // 1全部、2生效中、3已过期
      sortType: '1', // 1ID、2到期时间、3开启时间
      pagination: {
        page: 1,
        page_size: 10,
        total: 0,
      },
      usingPagination: {
        page: 1,
        page_size: 10,
        total: 0,
      },
      expiredPagination: {
        page: 1,
        page_size: 10,
        total: 0,
      },
      month_ad_count: 0,
      month_contribution: 0,
      month_player_count: 0,
      month_total_time: 0,
      yesterday_ad_count: 0,
      yesterday_contribution: 0,
      yesterday_player_count: 0,
      yesterday_total_time: 0,
      unvalidCount: 0,
      validCount: 0,
      allCount: 0,
      dataLoaded: {
        all: false,
        using: false,
        expired: false,
      },
      dataLoading: false,
    };
  },
  computed: {
    selectAllAll: function () {
      return this.multipleSelectionAll.length === this.allData.length;
    },
    selectAllExpired: function () {
      return (
        this.multipleSelectionExpired.length === this.serversExpired.length
      );
    },
    selectAllUsing: function () {
      return this.multipleSelectionUsing.length === this.serversUsing.length;
    },
  },
  created() {
    const developerInfo = JSON.parse(sessionStorage.getItem('developerInfo'));
    if (developerInfo.level) {
      this.isDeveloper = true;
    } else {
      this.isDeveloper = false;
    }
    this.getAllList(this.pagination);
    getCloudOverview().then(res => {
      if (res.code === 0) {
        const {
          month_ad_count,
          month_contribution,
          month_player_count,
          month_total_time,
          yesterday_ad_count,
          yesterday_contribution,
          yesterday_player_count,
          yesterday_total_time,
        } = res.data;
        this.month_ad_count = month_ad_count;
        this.month_contribution = month_contribution;
        this.month_player_count = month_player_count;
        this.month_total_time = (month_total_time / 60).toFixed(2);
        this.yesterday_ad_count = yesterday_ad_count;
        this.yesterday_contribution = yesterday_contribution;
        this.yesterday_player_count = yesterday_player_count;
        this.yesterday_total_time = (yesterday_total_time / 60).toFixed(2);
      }
    });
    this.Report('view', 'CloudServicePage');
  },
  watch: {
    activeName: function (val) {
      console.log(
        'mixins watch activeName',
        ACTIVE_NAME[val],
        this.dataLoaded[ACTIVE_NAME[val]],
      );
      if (!this.dataLoaded[ACTIVE_NAME[val]]) {
        this.changeSortType();
        this.dataLoaded[ACTIVE_NAME[val]] = true;
      }
    },
  },
  methods: {
    handleSearchChange(val) {
      console.log('handleSearchChange---', val);
      if (!val) {
        this.changeSortType();
      }
    },
    handleAllSelectionChange(val) {
      this.multipleSelectionAll = val;
      this.currServersCount = val.length;
    },
    handleUsingSelectionChange(val) {
      this.multipleSelectionUsing = val;
      this.currServersCount = val.length;
    },
    handleExpiredSelectionChange(val) {
      this.multipleSelectionExpired = val;
      this.currServersCount = val.length;
    },
    getAllList(pagination) {
      this.dataLoading = true;
      getCloudList(
        Object.assign({}, pagination, {
          sort_type: this.sortType,
          time_type: this.activeName,
        }),
      ).then(res => {
        console.log('getCloudList---', res);
        this.dataLoading = false;
        this.initDataLoading = false;
        if (res.code === 0) {
          const { data } = res;
          const { total_count: totalCount, list } = data;
          const _list = list.map(li => {
            li.expired = li.expire_time * 1000 <= Date.now();
            return li;
          });
          switch (this.activeName) {
            case '1':
              this.allData = _list;
              this.dataLoaded.all = true;
              break;
            case '2':
              this.serversUsing = _list;
              this.dataLoaded.using = true;
              break;
            case '3':
              this.serversExpired = _list;
              this.dataLoaded.expired = true;
              break;
          }
          this.pagination.total = totalCount;
          this.usingPagination.total = data.valid_count;
          this.expiredPagination.total = data.unvalid_count;
          this.allCount = data.total_count;
          this.unvalidCount = data.unvalid_count;
          this.validCount = data.valid_count;
          if (!totalCount) {
            this.noAnyServer = true;
            this.$route.meta.title = '服务器';
          }
        }
      });
    },
    changeSortType() {
      const pagination =
        this.activeName === '1'
          ? this.pagination
          : this.activeName === '2'
          ? this.usingPagination
          : this.expiredPagination;
      this.getAllList(pagination);
    },
    allDataPageChange(page) {
      this.pagination.page = page;
      this.getAllList(this.pagination);
    },
    usingDataPageChange(page) {
      this.usingPagination.page = page;
      this.getAllList(this.usingPagination);
    },
    expiredDataPageChange(page) {
      this.expiredPagination.page = page;
      this.getAllList(this.expiredPagination);
    },
    isWarnDay(time) {
      return isWarnDay(time);
    },
    handleTabsClick(name) {
      if (typeof name !== 'string') {
        name = name.name;
      }
      console.log('handleTabsClick---', name);
      // this.currServers = []
    },
    getCurrPagination() {
      let pagination;
      switch (this.activeName) {
        case '1':
          pagination = this.pagination;
          break;
        case '2':
          pagination = this.usingPagination;
          break;
        case '3':
          pagination = this.expiredPagination;
          break;
      }
      return pagination;
    },
    async getSearchResult(pagination, queryString) {
      const res = await cloudSearch(
        Object.assign({}, pagination, {
          time_type: this.activeName,
          title: queryString,
        }),
      );
      const { code, data } = res;
      const { list, total_count: totalCount } = data;
      if (code === 0) {
        switch (this.activeName) {
          case '1':
            this.pagination.total = totalCount;
            this.allData = list;
            break;
          case '2':
            this.usingPagination.total = totalCount;
            this.validCount = totalCount;
            this.serversUsing = list;
            break;
          case '3':
            this.expiredPagination.total = totalCount;
            this.unvalidCount = totalCount;
            this.serversExpired = list;
            break;
        }
      }
    },
    batchRenew(type) {
      let currServers;
      switch (type) {
        case 'all':
          currServers = this.multipleSelectionAll;
          break;
        case 'using':
          currServers = this.multipleSelectionUsing;
          break;
        case 'expired':
          currServers = this.multipleSelectionExpired;
          break;
      }
      if (!currServers.length) {
        this.$message
          ? this.$message.error('请勾选服务器后操作')
          : this.$toast.fail('请勾选服务器后操作');
        return;
      }
      localStorage.setItem('renewItems', JSON.stringify(currServers));
      this.$router.push({
        name: 'cloudServerBuy',
        params: { currServers: currServers, type: 'renew' },
      });
    },
    querySearchAsync(queryString) {
      if (queryString) {
        this.getSearchResult(this.getCurrPagination(), queryString);
      } else {
        this.getAllList(this.getCurrPagination());
      }
    },
    debounceSearch: debounce(async function (queryString) {
      // 给移动端用，因为 van-input 不自带防抖
      if (queryString) {
        this.getSearchResult(this.getCurrPagination(), queryString);
      } else {
        this.getAllList(this.getCurrPagination());
      }
    }, 500),
  },
  filters: {
    setDefaultMapImg(url) {
      return _setDefaultMapImg(url);
    },
    remainderTime(expiredTime) {
      if (('' + expiredTime).length < 13) expiredTime *= 1000;
      const _remainderTime = expiredTime - Date.now();
      let remainderDay = Math.round(_remainderTime / ONE_DAY);
      remainderDay = remainderDay <= 0 ? 0 : remainderDay;
      return `${remainderDay}天（${formatTime(expiredTime)}到期）`;
    },
    roomType(type) {
      return ROOM_TYPE[type];
    },
    format10Thousand(num, digit) {
      num = parseFloat(num, 10);
      if (num >= 10000) {
        num = (num / 10000).toFixed(2);
      } else if (digit) {
        num = num.toFixed(digit);
      }
      return num;
    },
    getStat(stat) {
      return statTxt[stat];
    },
  },
};
